<template>
    <div class="form">
        <div class="form-item">
            <div class="label">
                <div>手机号码</div>
                <div class="error">{{ errMsg.phone }}</div>
            </div>
            <div class="value">
                <el-input
                    size="large"
                    :class="{ error: errMsg.phone }"
                    @focus="onClearErr('phone')"
                    v-model="form.phone"
                    placeholder="请输入您的手机号"
                    :maxLength="11"
                ></el-input>
            </div>
        </div>
        <div class="form-item">
            <div class="label">
                <div>手机验证码</div>
                <div class="error">{{ errMsg.smsCode }}</div>
            </div>
            <div class="input">
                <el-input
                    size="large"
                    :class="{ error: errMsg.smsCode }"
                    @focus="onClearErr('smsCode')"
                    v-model="form.smsCode"
                    placeholder="请输入您的验证码"
                    :maxLength="6"
                ></el-input>
                <div class="btn" @click="onGetCode">
                    {{ remainTime ? `${remainTime}S` : '获取验证码' }}
                </div>
            </div>
        </div>
        <!-- 图形验证码 -->
        <graph-code
            :visible.sync="dialogVisible"
            @onOk="onOk"
            @onClose="onHideDialog"
            ref="graphCode"
            :phone="form.phone"
            type="login"
        />
    </div>
</template>
<script>
import { validatePhone } from '@/utils/validate';
import GraphCode from '@/components/Graph-Code';
export default {
    name: 'Phone',
    components: {
        GraphCode
    },
    data() {
        return {
            form: {
                phone: '',
                smsCode: ''
            },
            errMsg: {
                phone: '',
                smsCode: ''
            },
            remainTime: 0,
            dialogVisible: false
        };
    },
    methods: {
        // 提交
        submit() {
            this.errMsg = {
                ...this.errMsg,
                phone: validatePhone(this.form.phone),
                smsCode: this.form.smsCode ? '' : '请输入验证码'
            };
            const { phone, smsCode } = this.errMsg;
            if (phone || smsCode) return false;
            return this.form;
        },
        // 清除错误信息
        onClearErr(type) {
            this.errMsg = {
                ...this.errMsg,
                [type]: ''
            };
        },
        // 获取验证码
        onGetCode() {
            if (!this.form.phone || this.form.phone.length !== 11) {
                this.errMsg = {
                    ...this.errMsg,
                    phone: validatePhone(this.form.phone)
                };
                return;
            }
            if (this.remainTime > 0) return;
            this.dialogVisible = true;
        },
        onOk() {
            // this.dialogVisible = false;
            // 清空输入的值
            this.$refs.graphCode.onClear();
            let count = 59;
            this.remainTime = count--;
            this.timer = setInterval(() => {
                if (count <= 0) clearInterval(this.timer);
                this.remainTime = count--;
            }, 1000);
        },
        onHideDialog() {
            // this.dialogVisible = false;
            // 清空输入的值
            this.$refs.graphCode.onClear();
        }
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
$baseColor: #f56c6c;
.form {
    .form-item {
        margin-bottom: 18px;
        text-align: left;
    }
    .error {
        border-color: $baseColor;
    }
    .label {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #2d2e33;
        line-height: 14px;
        position: relative;
        .error {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: $baseColor;
            line-height: 12px;
        }
        .tips {
            position: absolute;
        }
    }
    .input {
        position: relative;
        .btn {
            cursor: pointer;
            position: absolute;
            right: 12px;
            top: 50%;
            margin-top: -6px;
            height: 14px;
            font-size: 14px;
            font-weight: 400;
            color: #0772eb;
            line-height: 14px;
        }
    }
}
</style>
